/**
 * Indicates whether the current Angular build is a test environment
 * (local or development). Production builds must never show the banner.
 */
export function estEnvironnementDeTest(env: { production: boolean }): boolean {
  return env.production !== true;
}
